import ReactPaginatePkg from 'react-paginate';
import PropTypes from 'prop-types';
import { PiCaretLeft, PiCaretRight } from 'react-icons/pi';

const ReactPaginate = ReactPaginatePkg.default ?? ReactPaginatePkg;

const Paginate = ({ pageCount, onPageChange, forcePage, ...props }) => {
  const safePageCount = Math.max(1, Math.ceil(pageCount) || 0);
  const safeForcePage = forcePage == null
    ? undefined
    : Math.min(Math.max(0, forcePage), safePageCount - 1);

  return (
    <ReactPaginate
      pageCount={safePageCount}
      pageRangeDisplayed={5}
      marginPagesDisplayed={1}
      containerClassName="flex items-center justify-center bg-panel text-gray-700"
      activeLinkClassName="text-white bg-primary-400"
      disabledLinkClassName="paginate_link-disabled"
      breakLinkClassName="paginate_link"
      pageLinkClassName="paginate_link"
      previousLinkClassName="paginate_link rounded-l-md border-l"
      nextLinkClassName="paginate_link rounded-r-md"
      previousLabel={<PiCaretLeft size={20} />}
      nextLabel={<PiCaretRight size={20} />}
      onPageChange={onPageChange}
      forcePage={safeForcePage}
      {...props}
    />
  );
};

Paginate.propTypes = {
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  forcePage: PropTypes.number,
};

export default Paginate;
